<template>
  <div class="aboutDuty">
    <div>
      <div class="dutyTitle">
        <div class="colorTitle">
          <span>///</span> 软实力 <span>///</span>
        </div>
      </div>
      <div class="newsList">
        <div class="list">
          <div class="imgArea">
            <img src="../assets/images/brief_picture_01.png" alt="">
          </div>
          <div class="textArea">
            <div class="compTitleTwo">壹心科技与北航成立联合实验室</div>
            <div class="compText">2020年8月，公司携手北京航空航天大学成立联合实验室，瞄准未来建立保险大数据和AI人工智能系统，助力保险代理人精准高效服务客户。</div>
          </div>
        </div>
        <div class="list">
          <div class="imgArea">
            <img src="../assets/images/brief_picture_02.png" alt="">
          </div>
          <div class="textArea">
            <div class="compTitleTwo">携手上海财大打造壹心学院财经分院</div>
            <div class="compText">
              2020年8月，公司与上海财经大学签署了合作协议，共同打造公司壹心学院财经分院，为每一位加盟公司平台的成员提供一流的线上线下培训、教育和交流。诚挚邀请有志于保险事业的朋友携手同行。</div>
          </div>
        </div>
        <div class="list">
          <div class="imgArea">
            <img src="../assets/images/brief_picture_03.png" alt="">
          </div>
          <div class="textArea">
            <div class="compTitleTwo">美年大健康助力壹心保险健康新篇章</div>
            <div class="compText">2020年6月，公司与美年大健康签署合作协议，从浙江省开始试点建立行业领先的保险+健康的业务板块，加强前置性健康管理服务，为客户提供专业科学的健康管理。</div>
          </div>
        </div>
        <div class="list">
          <div class="imgArea">
            <img src="../assets/images/brief_picture_04.png" alt="">
          </div>
          <div class="textArea">
            <div class="compTitleTwo">壹心学院落户嘉兴</div>
            <div class="compText">
              2018年10月，公司在浙江嘉兴设立壹心学院，分为行销、财经、教育、管理、科技五大体系，旨在为保险行业从业人员赋能专业化成长课程。致力于打造行业顶尖培训品牌，建设行业顶尖企业大学。</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div>
        <div class="colorTitle">
          <span>///</span> 暖实力 <span>///</span>
        </div>
      </div>
      <div class="newsList">
        <div class="list">
          <div class="imgArea">
            <img src="../assets/images/brief_picture_05.png" alt="">
          </div>
          <div class="textArea">
            <div class="compTitleTwo">设立浙江财经大学“科教基金”</div>
            <div class="compText">
              2019年10月，与浙江财经大学共同设立“科教基金”。校党委书记李金昌强调戚洪标先生返校设立基金凝聚着他对母校的深情厚谊,基金的设立也是对学校45周年华诞的献礼，具有良好的社会效应和示范作用。学校将会把科技基金落到实处,使其产生更大、更广、更深远的影响。,基金的设立也是对学校45周年华诞的献礼，具有良好的社会效应和示范作用。学校将会把科技基金落到实处,使其产生更大、更广、更深远的影响。
            </div>
          </div>
        </div>
        <div class="list">
          <div class="imgArea">
            <img src="../assets/images/brief_picture_06.png" alt="">
          </div>
          <div class="textArea">
            <div class="compTitleTwo">中华社会救助基金会“春藤成长计划”</div>
            <div class="compText">
              中华社会救助基金会公益项目“春藤成长计划”之“送课下乡”活动于2021年7月18—19日在广安市经开区第一小学正式启动。来自北京壹心壹翼科技有限公司子公司壹心保代的25个家庭共同参与了此次公益活动，用实际行动来践行公益，传递爱心。
            </div>
          </div>
        </div>
        <!-- <div class="list">
          <div class="imgArea">
            <img src="../assets/images/brief_picture_08.png" alt="">
          </div>
          <div class="textArea">
            <div class="compTitleTwo">暖心高效的理赔服务</div>
            <div class="compText">一份保单，一份服务，一份关爱。作为专业代理团队，我们在意客户的购买体验，更关注保单的理赔流程。当客户不幸发生风险事故，我们快速启动理赔服务机制，协助客户迅速完成与多家保险公司的对接，保证理赔流程顺利且高效。客户不仅第一时间收到理赔款，同时感受到了我们暖心理赔的服务优势。（图例客户获得理赔金60万元，豁免后续保费50万元 ）</div>
          </div>
        </div> -->
        <!-- <div class="list">
          <div class="imgArea">
            <img src="../assets/images/brief_picture_07.png" alt="">
          </div>
          <div class="textArea">
            <div class="compTitleTwo">壹心保代成为中国灾害防御协会会员单位</div>
            <div class="compText">
              中国灾害防御协会是全国性防减灾及救援应急管理等专业化组织，在自然灾害、基础建设、心理服务、安全教育等不同学科、领域承担着重大社会责任。壹心保代携手中国灾害防御协会，切实践行社会责任，致力于推广主动式风险防控理念并构建更加完善的灾害防减体系，积极为经济建设和社会发展做出贡献。
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutDuty',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.aboutDuty {
  width: 1024px;
  margin: 0 auto;

  .dutyTitle {
    .colorTitle {
      margin-top: 0;
    }
  }

  .newsList {
    margin-top: 40px;

    .list {
      display: flex;
      margin-bottom: 40px;
      width: 1024px;
      height: 172px;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);

      .imgArea {
        width: 304px;
        height: 172px;

        img {
          width: 304px;
          height: 172px;
        }
      }

      .textArea {
        padding: 20px 20px 10px;
        background-color: #FBFBFB;
        flex: 1;
      }

      .compText {
        margin-top: 12px;
      }

    }
  }

}
</style>